import { render } from "./BackToTopComponent.vue?vue&type=template&id=2f6b2599"
import script from "./BackToTopComponent.vue?vue&type=script&lang=js"
export * from "./BackToTopComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__